import { persistor } from '@/store';

/**
 * Shared logout / 401 cleanup — auth, cart, outlet content, React Query.
 * @param {{ purge?: boolean }} [options] — purge=true drops redux-persist storage (hard reset).
 */
export default async function clearSession(dispatch, queryClient, options = {}) {
	const { purge = false } = options;
	dispatch({ type: 'auth/setLogout' });
	dispatch({ type: 'cart/resetItems' });
	dispatch({ type: 'content/resetOutlet', payload: false });
	dispatch({ type: 'content/resetFetchAPI', payload: false });
	if (queryClient) {
		queryClient.clear();
	}
	if (purge && persistor) {
		try {
			await persistor.purge();
		} catch {
			// ignore purge errors; hard reload still clears most stuck state
		}
		try {
			localStorage.removeItem('persist:auth');
			localStorage.removeItem('persist:cart');
			localStorage.removeItem('persist:root');
		} catch {
			// ignore
		}
	}
}
